class AgencyArticlePriceResponse {
    public id: string;
    public geoId: string;
    public currency: string;
    public price: number;
    public articleId: string;
    public agencyId: string;
    public agencyName: string;
    public deliveryTimeDays?: number;

    constructor(
        id: string,
        geoId: string,
        currency: string,
        price: number,
        articleId: string,
        agencyId: string,
        agencyName: string,
        deliveryTimeDays?: number
    ) {
        this.id = id;
        this.geoId = geoId;
        this.currency = currency;
        this.price = price;
        this.articleId = articleId;
        this.agencyId = agencyId;
        this.agencyName = agencyName;
        this.deliveryTimeDays = deliveryTimeDays;
    }
}

export default AgencyArticlePriceResponse;